import { AwesomeSezzle } from "typings/awesomeSezzle";
import "./Sezzle.scss";

export class Sezzle
{
	public Sdk: typeof AwesomeSezzle;
	public Amount: string = "40.00";
	public InfoLink: HTMLElement;
	public Installments = 5;
	public InstallmentElement: HTMLElement;
	public ModalObserver: MutationObserver;
	public WidgetInstance: AwesomeSezzle;

	constructor()
	{
		const infoLink = document.querySelector("#sezzleInfo");
		const installmentElement = document.querySelector("#sezzleInstallments");

		if (infoLink)
		{
			this.InfoLink = infoLink as HTMLElement;
			this.InfoLink.addEventListener("click", this.DisplayInformation);
			this.Amount = this.InfoLink.getAttribute("data-amount");
		}

		if (installmentElement)
		{
			this.InstallmentElement = installmentElement as HTMLElement;
		}
	}

	public DisplayInformation = async (e?: Event): Promise<void> =>
	{
		if (typeof e !== "undefined")
		{
			e.preventDefault();
		}

		if (!this.Sdk)
		{
			const loaded = await this.InitializeSdk();

			if (loaded)
			{
				await this.DisplayInformation();
			}

			return;
		}
		else
		{
			this.OpenModal();
		}
	};

	public HideModal = (): void =>
	{
		document.body.classList.remove("sezzle-modal-open");
		this.ModalObserver?.disconnect();
	};

	public InitializeSdk = async (): Promise<boolean> =>
	{
		if (!this.Sdk)
		{
			try
			{
				const sezzleSdk = await import("@sezzle/sezzle-static-widget");
				this.Sdk = sezzleSdk.default;

				const widget = document.createElement("div");
				widget.id = "sezzle-widget";
				widget.setAttribute("style", "display: none !important;");
				document.body.appendChild(widget);

				this.WidgetInstance = new this.Sdk({
					amount: this.Amount,
					renderElement: "sezzle-widget",
				});

				this.WidgetInstance.init();
				return true;
			}
			catch (error)
			{
				console.error("Sezzle: Failed to load SDK", error);
				return false;
			}
		}
		else
		{
			console.warn("Sezzle: SDK is already initialized.");
			return true;
		}
	};

	public OpenModal = (): void =>
	{
		if (typeof this.ModalObserver === "undefined")
		{
			this.ModalObserver = new MutationObserver(this.HideModal);
		}

		const modalNode: HTMLElement = document.querySelector(".sezzle-checkout-modal-lightbox");

		if (modalNode !== null)
		{
			modalNode.style.display = "block";

			document.body.classList.add("sezzle-modal-open");

			this.ModalObserver?.observe(modalNode, {
				attributes: true,
				attributeFilter: ["style"]
			});
		}
		else
		{
			const domObserver = new MutationObserver((_, obs) =>
			{
				const injectedModal: HTMLElement = document.querySelector(".sezzle-checkout-modal-lightbox");

				if (injectedModal !== null)
				{
					clearTimeout(timeout);
					obs.disconnect();
					this.OpenModal();
				}
			});

			const timeout = setTimeout(() =>
			{
				domObserver.disconnect();
				console.error("Sezzle: modal element never appeared in the DOM.");
			}, 5000);

			domObserver.observe(document.body, { childList: true, subtree: true });
		}
	};

	public UpdateAmount = (amount: string): void =>
	{
		this.Amount = amount.replace(/[^0-9.]/g, "");

		if (typeof this.InfoLink !== "undefined")
		{
			this.InfoLink.setAttribute("data-amount", this.Amount);
		}

		if (typeof this.InstallmentElement !== "undefined")
		{
			this.InstallmentElement.innerHTML = `<span>$${(parseFloat(this.Amount) / this.Installments).toFixed(2)}</span>`;
		}

		if (typeof this.WidgetInstance !== "undefined")
		{
			this.WidgetInstance.alterPrice(this.Amount);
		}
	};
}